/* eslint-disable react/no-this-in-sfc */
import axios from 'axios'
import { createContext, useState, useRef } from 'react'
import { useStorage } from 'hooks'

import { IObject } from 'interfaces'
import { optionsLevels } from 'helper/utils'
import { CONNECTION, SOCKET } from 'configs/configs.js'

interface IGeneralContextType {
  data: any
  dictionary: IObject
  setData: any
  gestor?: any
  user: any
  gestorList?: any
  speciaList?: any
}

export const GeneralContext = createContext<IGeneralContextType>(null!)

export function GeneralProvider({ children }: { children: React.ReactNode }) {
  const [data, setData] = useState()
  const gestorRef = useRef<any[]>([])
  const [user] = useStorage('User')
  const [token] = useStorage('Token')
  const gestorList = useRef<any[]>([])
  const specialistList = useRef<any[]>([])
  const gestorSpeciaList = useRef<any[]>([])
  const defaultGestor = { id: 'default', name: 'Neo', profilePicture: '' }
  const dic = useRef<IObject>({})
  const levelList = useRef<any[]>([])

  const value: any = {
    dictionary: {
      import(dt: IObject) {
        dic.current = dt
      },
      translate(word: string) {
        return dic.current[word.toUpperCase()]
      },
    },
    user: {
      get() {
        return user || {}
      },
      level() {
        if (!user) return
        return optionsLevels[user.level]
          ? optionsLevels[user.level]
          : 'SPECIALIST'
      },
      isSpecialist() {
        if (!user) return false
        const decimalValue = parseInt(user.level, 16)
        const binaryString = decimalValue.toString(2)
        const permitionList = Array.from(binaryString).map(Number)
        return permitionList.reverse().pop() === 1
      },
    },
    gestor: {
      types: {
        GESTOR: String([0, 0, 1, 0, 0, 0, 0]),
        SPECIALIST: String([1, 0, 0, 0, 0, 0, 0]),
        GESTOR_SPECIALIST: String([1, 0, 1, 0, 0, 0, 0]),
      },
      setList(list: any[]) {
        levelList.current = list
      },
      list() {
        return levelList.current.map((level: string) => ({
          [level]: dic.current[level.toUpperCase()],
        }))
      },
      default: defaultGestor,
      get() {
        return gestorRef.current
      },
      set(v: any[]) {
        v.push(defaultGestor)
        gestorRef.current = v
      },
      async syncronize(tk: string) {
        // ****** WARNING *****
        // NUNCA MUDE ESSE && POR ||
        if (!tk && !token) return
        const opt = { headers: { Authorization: `Bearer ${tk || token}` } }
        const r = await axios.get(`${CONNECTION.URL}/gestor/gestor`, opt)
        // console.log(r)
        const list: [] = r.data.data
        ;[
          ['gestorList', 'GESTOR'],
          ['speciaList', 'SPECIALIST'],
          ['gestorSpeciaList', 'GESTOR_SPECIALIST'],
        ].forEach((pair) => {
          const [l, k]: string[] = pair
          const gList = list
            .filter((usr: any) => String(usr.level) === value.gestor.types[k])
            .map((item: any) => {
              return { ...item, label: item.name, value: item.id }
            })
          value[l].set(gList)
        })
        gestorRef.current = list
      },
    },
    gestorList: {
      get() {
        return gestorList.current
      },
      set(list: any[]) {
        return (gestorList.current = list)
      },
    },
    speciaList: {
      get() {
        return specialistList.current
      },
      set(list: any[]) {
        return (specialistList.current = list)
      },
    },
    gestorSpeciaList: {
      get() {
        return gestorSpeciaList.current
      },
      set(list: any[]) {
        return (gestorSpeciaList.current = list)
      },
    },
    data,
    setData,
  }

  return (
    <GeneralContext.Provider value={value}>{children}</GeneralContext.Provider>
  )
}
